import { FC } from "react";

import { ROUTES } from "constants/routes";

import useResetPassword from "./hooks/useResetPassword";

import { Typography, useTheme } from "@mui/material";

import { InputPassword } from "components/common/inputs/InputPassword";
import { Button } from "components/common/Button";
import { Link } from "components/common/Link";
import { ConfirmationModal } from "components/common/modals/ConfirmationModal";
import { PasswordPolicy } from "components/common/PasswordPolicy";

import {
  StyledResetPassword,
  StyledResetPasswordFields,
  StyledResetPasswordHeadings,
} from "styles/features/reset-password";

const ResetPassword: FC = () => {
  const theme = useTheme();

  const {
    password,
    confirmedPassword,
    loading,
    validFieldErrors,
    errorText,
    extraErrorText,
    infoModalIsOpen,
    listOfPolicy,
    handlePasswordChange,
    handleConfirmedPasswordChange,
    handleSubmit,
    checkFieldValidation,
    onInfoModalClose,
    handleRedirectToLogIn,
  } = useResetPassword();

  return (
    <StyledResetPassword>
      <StyledResetPasswordHeadings>
        <Typography variant="h1" color={theme.palette.common.black}>
          Update password
        </Typography>
        <Typography
          variant="bodyL"
          color={theme.palette.common.black}
          paragraph
          fontWeight={300}
          marginBottom={0}
        >
          Please provide a new password for the change. Please ensure that you
          enter the same password in both fields
        </Typography>
      </StyledResetPasswordHeadings>
      <StyledResetPasswordFields>
        <InputPassword
          value={password}
          onChange={handlePasswordChange}
          placeholder="Enter your password"
          label="New Password"
          errorText={errorText || "Please enter the new password"}
          disabled={loading}
          error={validFieldErrors.includes("password")}
          onBlur={checkFieldValidation(password, "password")}
        />
        <InputPassword
          value={confirmedPassword}
          onChange={handleConfirmedPasswordChange}
          placeholder="Confirm new  password"
          label="Confirm the New Password"
          errorText={extraErrorText || "Please confirm the new password"}
          disabled={loading}
          error={validFieldErrors.includes("confirmedPassword")}
          onBlur={checkFieldValidation(confirmedPassword, "confirmedPassword")}
        />
      </StyledResetPasswordFields>
      <PasswordPolicy listOfPolicy={listOfPolicy} />
      <Button
        className="reset-password__btn"
        onClick={handleSubmit}
        disabled={loading}
        isLoading={loading}
      >
        Update password
      </Button>
      <Typography
        variant="bodyL"
        color={theme.palette.customGrey.dark}
        paragraph
        gap="16px"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        Don't have an account yet?
        <Link route={ROUTES.signUp} className="sign-in__forgot">
          Sign up
        </Link>
      </Typography>
      <ConfirmationModal
        title="Success!"
        text="You have successfully changed your password"
        submitBtnText="Log in"
        type="success"
        open={infoModalIsOpen}
        onClose={onInfoModalClose}
        onSubmit={handleRedirectToLogIn}
        onCancel={onInfoModalClose}
      />
    </StyledResetPassword>
  );
};

export default ResetPassword;
